import { RefBool, RefNumber, RefString } from "@tblabs/truffle";
import { RawBasketItem } from "./Basket/RawBasketItem";
import { DeliveryForm } from "./DeliveryForm";
import { PaymentForm } from "./Payment/PaymentForm";
import { RawHuman } from "./RawHuman";
import { ReturnForm } from "./ReturnForm";
import { TicketMeta } from "./TicketMeta";


export interface Invoice
{
    CompanyName: string;
    CompanyAddress: string;
    CompanyNIP: string;
}

export interface RawDiscount // Copy from website
{
    Type: string;
    Target: string;
    Name: string;
    Code: string;
    Limit: number;
    Value: number; 
    Percent?: number; // Legacy (was used till 27.01.2026)
    Description: string;  
    IsVisible: boolean;
}

export class Discount
{
    public Type = new RefString();
    public Target = new RefString();
    public Code = new RefString();
    public Value = new RefNumber();
    public IsVisible = new RefBool();
    public Name = new RefString();
    public Description = new RefString();
    public Limit = new RefNumber();

    public get AsRaw(): RawDiscount
    {
        return {
            Name: this.Name.value,
            Code: this.Code.value,
            Value: this.Value.value,
            Description: this.Description.value,
            Target: this.Target.value,
            Type: this.Type.value,
            Limit: this.Limit.value,
            IsVisible: this.IsVisible.value,
        };
    }

    constructor(raw: Partial<RawDiscount>)
    {
        this.Name.value = raw.Name || "";
        this.Code.value = raw.Code || "";
        this.Value.value = raw.Value || raw.Value || 0;
        this.Description.value = raw.Description || "";
        this.Target.value = raw.Target || "";
        this.Type.value = raw.Type || "";
        this.Limit.value = raw.Limit || 0;
        this.Value.value = raw.Value ?? raw.Percent ?? 0;
        this.IsVisible.value = raw.IsVisible ?? false;
    }
}

export interface RawBasketInfo
{
    PriceBeforeDiscount: number;
    PriceAfterDiscount: number;
    Discounts: RawDiscount[];
}

export interface Ticket
{
    Id: string;
    Meta: TicketMeta;
    BasketList: RawBasketItem[];   
    BasketInfo: RawBasketInfo;
    Customer: RawHuman;
    Delivery: DeliveryForm;
    Return: ReturnForm;
    DepositPaymentForm: PaymentForm;
    BasketPaymentForm: PaymentForm;
    WithTraining: boolean;
    PickupPlace: string;
    Invoice?: Invoice;
    Notes: string;
}
